import { Action } from '@ngrx/store';
import { CompanyVoteProposalNameSearchFilter } from '../../models/companyVoteProposalNameSearchFilter';

export enum ECompanyVoteProposalNameListActions {
  SetSearchFilter = '[Company Vote Proposal Name List] SET SEARCH FILTER',
  SetPagination = '[Company Vote Proposal Name List] SET PAGINATION',
  SetSort = '[Company Vote Proposal Name List] SET SORT',
  ClearFilters = '[Company Vote Proposal Name List] CLEAR FILTERS'
}

export class SetSearchFilter implements Action {
  public readonly type = ECompanyVoteProposalNameListActions.SetSearchFilter;
  constructor(public payload: CompanyVoteProposalNameSearchFilter) {}
}

export class SetPagination implements Action {
  public readonly type = ECompanyVoteProposalNameListActions.SetPagination;
  constructor(public payload: { currentPage: number; pageSize: number }) {}
}

export class SetSort implements Action {
  public readonly type = ECompanyVoteProposalNameListActions.SetSort;
  constructor(public payload: { sortBy: string; ascending: boolean }) {}
}

export class ClearFilters implements Action {
  public readonly type = ECompanyVoteProposalNameListActions.ClearFilters;
}

export type CompanyVoteProposalNameListActions =
  | SetSearchFilter
  | SetPagination
  | SetSort
  | ClearFilters;
